import { push } from 'redux-first-history';

import { mergeQueryParams } from 'utils/searchQuery';
import { getLocationSearchParams, getPathname } from 'redux/modules/routing/selectors';
import { getSortByQueryParam } from 'redux/modules/search/selectors';

import { sortBy } from 'redux/modules/search/actions/sort-by';

export default ({ order, stickyFilter, noScroll = false, refinement = false }) =>
  (dispatch, getState) => {
    const state = getState();
    const currentSortBy = getSortByQueryParam(state);
    if (currentSortBy !== order) {
      const sortQueryString = dispatch(sortBy({ order, stickyFilter }));
      const nextQueryString = mergeQueryParams(getLocationSearchParams(state), sortQueryString);

      dispatch(
        push(`${getPathname(state)}${nextQueryString}`, {
          noScroll,
          refinement,
        }),
      );
    }
  };
